import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import './App.css';

import { AuthProvider } from './lib/auth';
import { ProtectedRoute } from './components/ProtectedRoute';

import Landing from './pages/Landing';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import SearchPage from './pages/SearchPage';
import Balance from './pages/Balance';
import History from './pages/History';
import AdminPanel from './pages/AdminPanel';
import Maintenance from './pages/Maintenance';
import ImageResize from './pages/ImageResize';
import ForgotPassword from './pages/ForgotPassword';
import Profile from './pages/Profile';
import VerifyEmail from './pages/VerifyEmail';
import VerifyPending from './pages/VerifyPending';
import Support from './pages/Support';
import SplashScreen from './components/SplashScreen';
import LegalPage from './pages/LegalPage';
import PageTransition from './components/PageTransition';

function App() {
  return (
    <div className="App dark">
      <SplashScreen />
      <AuthProvider>
        <BrowserRouter>
          <AnimatedRoutes />
  
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <PageTransition key={location.pathname}>
      <Routes location={location}>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/kvkk" element={<LegalPage type="kvkk" />} />
        <Route path="/kullanim-sartlari" element={<LegalPage type="terms" />} />
        <Route path="/aydinlatma-metni" element={<LegalPage type="disclosure" />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/verify-pending" element={<VerifyPending />} />
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/search" element={<ProtectedRoute><SearchPage /></ProtectedRoute>} />
        <Route path="/balance" element={<ProtectedRoute><Balance /></ProtectedRoute>} />
        <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
        <Route path="/history" element={<ProtectedRoute><History /></ProtectedRoute>} />
        <Route path="/tools/resize" element={<ProtectedRoute><ImageResize /></ProtectedRoute>} />
        <Route path="/support" element={<ProtectedRoute><Support /></ProtectedRoute>} />
        <Route path="/ai-studio" element={<ProtectedRoute><Maintenance title="AI Studio" /></ProtectedRoute>} />
        <Route path="/video" element={<ProtectedRoute><Maintenance title="Video Üretici" /></ProtectedRoute>} />
        <Route path="/admin" element={<ProtectedRoute adminOnly><AdminPanel /></ProtectedRoute>} />
      </Routes>
    </PageTransition>
  );
}

export default App;
